import { render, staticRenderFns } from "./QBPtopshop.vue?vue&type=template&id=ecca2a62&scoped=true&"
import script from "./QBPtopshop.vue?vue&type=script&lang=ts&"
export * from "./QBPtopshop.vue?vue&type=script&lang=ts&"
import style0 from "./QBPtopshop.vue?vue&type=style&index=0&id=ecca2a62&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca2a62",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoaderSpinner: require('C:/inetpub/wwwroot/bike-flights/components/LoaderSpinner.vue').default})
